import { getApi } from 'smx-components';
import { tokenRefresher } from '../utilities/tokenRefresher';
import { store } from '../store';

export const Api = getApi(() => tokenRefresher(store));
